import React from 'react'
import PropTypes from 'prop-types'

// Components
import WidgetList from './WidgetList'
import CategoryDropdownContainer from './containers/CategoryDropdownContainer'

// Filter/sort widgets by category
export function categoryWidgets(widgets, categoryName) {
	return Object.keys(widgets)
		.filter(widget => widgets[widget].category === categoryName)
		.sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0))
		.map(key => widgets[key])
}

// Presentational Component
const CategoryWidgetList = ({ categories, widgets, categoryName }) => {
	if (categoryName) {
		// Only show widgets for requested category
		return (
			<div>
				<div className="responsive-small">
					<CategoryDropdownContainer widgets={categoryWidgets(widgets, categoryName)} />
				</div>
				<WidgetList widgets={categoryWidgets(widgets, categoryName)} />
			</div>
		)
	} else {
		// List categories and show widgets in each category
		return (
			<div>
				<div className="responsive-small">
					<CategoryDropdownContainer widgets={categoryWidgets(widgets, categoryName)} />
				</div>
				<ul className="category-list list-unstyled">
					{Object.keys(categories)
						.sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0))
						.map(category => {
							return (
								<li key={categories[category].name}>
									<h2>{categories[category].name} Widgets</h2>
									<WidgetList
										widgets={categoryWidgets(widgets, categories[category].name)}
									></WidgetList>
								</li>
							)
						})}
				</ul>
			</div>
		)
	}
}

CategoryWidgetList.propTypes = {
	categories: PropTypes.object.isRequired,
	widgets: PropTypes.object.isRequired,
	categoryName: PropTypes.string,
}

export default CategoryWidgetList



// WEBPACK FOOTER //
// ./src/components/widgets/CategoryWidgetList.js